// src/components/lekhi/TextView.js
import React from 'react';
import './TextView.css';

const TextView = ({ textContent, language, onComplete, onBack }) => {
  const labels = language === 'mr'
    ? { back: '← मागे', next: 'पुढे', title: 'वाचा' }
    : { back: '← Back', next: 'Continue', title: 'Read' };

  const renderTextWithBold = (text) => {
    if (!text) return null;
    const paragraphs = text.split(/\n\n+/).filter(p => p.trim());
    return paragraphs.map((para, pIdx) => {
      const parts = para.split(/(\*\*[^*]+\*\*)/g);
      return (
        <p key={pIdx} className="lk-text-paragraph">
          {parts.map((part, i) => {
            if (part.startsWith('**') && part.endsWith('**')) {
              return <strong key={i} className="lk-text-bold">{part.slice(2, -2)}</strong>;
            }
            return <span key={i}>{part}</span>;
          })}
        </p>
      );
    });
  };

  return (
    <div className="lk-text-container">
      <div className="lk-text-header">
        <button className="back-btn" onClick={onBack}>{labels.back}</button>
        <div className="lk-text-title">{labels.title}</div>
        <div style={{ width: 60 }} />
      </div>
      <div className="lk-text-body">
        {renderTextWithBold(textContent?.text)}
      </div>
      <div className="lk-text-footer">
        <button className="lk-text-next-btn" onClick={onComplete}>{labels.next}</button>
      </div>
    </div>
  );
};

export default TextView;